module.exports = __webpack_public_path__ + "static/media/welcome2.547d7d30.jpg";